import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import Amount from './Amount';
import AmountPill from './AmountPill';
import Text from './Text';
import { rem } from './values';
import { CardView } from './CardView';
const DepositAmountSelector = ({ min, max, amount, options, footnote, setAmount, availableAmount, remainingAllowance, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const isCustomAmount = !!amount && !options.includes(amount);
    const handleCustomPress = useCallback(() => {
        navigation.navigate('DepositSelectCustomAmount', {
            min,
            max,
            availableAmount,
            remainingAllowance,
            onContinue: setAmount,
            initialAmount: amount,
            suggestedAmounts: options,
        });
    }, [
        amount,
        availableAmount,
        max,
        min,
        options,
        remainingAllowance,
        setAmount,
    ]);
    return (<CardView withPadding noMarginBottom noMarginTop>
      <View style={styles.row}>
        <Text Text-16>Deposit amount</Text>
        <Amount Numbers-16 showFraction={false} value={{ value: amount, currency: 'GBP' }}/>
      </View>
      <View style={styles.pillRow}>
        {options.map((option) => (<AmountPill key={String(option)} value={option} currency="GBP" style={styles.pill} selected={amount === option} onPress={() => setAmount(option)}/>))}
        <TouchableBounce onPress={handleCustomPress} style={[
            styles.pill,
            styles.customPill,
            isCustomAmount && styles.customPillActive,
            {
                flex: 1,
            },
        ]}>
          <Text Text-14 color={isCustomAmount
            ? colors.text.textOnBrandLight
            : colors.text.secondary}>
            Custom
          </Text>
        </TouchableBounce>
      </View>
      {!!footnote && (<Text TextThin-14 Negative style={styles.footnote}>
          {footnote}
        </Text>)}
    </CardView>);
};
export default memo(DepositAmountSelector);
const styleSet = createStyleSheets((colors) => ({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    pillRow: {
        gap: rem(8),
        flexDirection: 'row',
        paddingTop: rem(16),
    },
    pill: {
        flex: 1,
        paddingHorizontal: 0,
    },
    customPill: {
        height: rem(34),
        alignItems: 'center',
        borderRadius: rem(10),
        justifyContent: 'center',
        backgroundColor: colors.buttons.secondary,
    },
    customPillActive: {
        backgroundColor: colors.buttons.brandLight,
    },
    footnote: {
        paddingTop: rem(12),
    },
}));
